// src/api/features/dashboard/api.ts
import { request } from "@/api/client";
import { PATHS } from "@/api/constants";

import type { AdminDashboardSummaryResult } from "./types";

/* =========================
 * Helpers (API envelope)
 * ========================= */

type ApiEnvelope<T> = { ok: boolean; message?: string; data: T; meta?: any };

function unwrap<T>(res: unknown): T {
  if (res && typeof res === "object" && "ok" in res && "data" in res) {
    return (res as ApiEnvelope<T>).data;
  }
  return res as T;
}

/* =========================
 * BASE URL
 * ========================= */

const BASE = PATHS.dashboard.base;

/* =========================
 * GET — /dashboard/admin/summary
 * ========================= */

/**
 * Fetch admin dashboard summary for a given period.
 *
 * Backend:
 * - Requires auth + admin role.
 * - Query params (optional): month (1..12), year (2000..2100)
 */
export async function getAdminDashboardSummary(params?: {
  month?: number;
  year?: number;
  employeeId?: number;
}): Promise<AdminDashboardSummaryResult> {
  const res = await request<
    AdminDashboardSummaryResult | ApiEnvelope<AdminDashboardSummaryResult>
  >({
    method: "GET",
    url: `${BASE}/admin/summary`,
    params,
  });

  return unwrap<AdminDashboardSummaryResult>(res);
}
